import { faTimes } from '@fortawesome/pro-light-svg-icons';

import { Box, IconButton, Typography } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

type Props = {
  children: React.ReactElement<any, any>;
  title: string;
  onClose: () => void;
};

export default function TooltipRecurring({ children, title, onClose }: Props) {
  return (
    <Box position="relative" maxWidth={260}>
      <IconButton
        aria-label="close"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: -4,
          right: -8,
          marginLeft: '10px'
        }}
      >
        <FontAwesomeSvgIcon icon={faTimes} sx={{ fontSize: '14px' }} />
      </IconButton>
      <Box px={2} pt={2} pb={1}>
        <Typography lineHeight={1.2} variant="body1" mx={1} textAlign="center">
          {title}
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          mt={1}
          gap={1}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
